import React from 'react';

const Spinner = () => (
  <section className="docs-content">
    <div className="auth0-spinner">
      <div className="spinner" />
    </div>
  </section>
);

export default Spinner;
